import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'LivePhotoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-live-photo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11.296 11.29a1 1 0 1 0 1.414 1.415"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.473 8.456a5 5 0 1 0 7.076 7.066m1.365 -2.591a5 5 0 0 0 -5.807 -5.851"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.9 20.11v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.04 17.61v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20.77 14v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20.77 10v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.04 6.39v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.9 3.89v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.1 3.89v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.96 6.39v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.23 10v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.23 14v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.96 17.61v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.1 20.11v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 21v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};